/**
 * This program is free software; you can redistribute it and/or
 * modify it under the terms of the GNU General Public License
 * as published by the Free Software Foundation; under version 2
 * of the License (non-upgradable).
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU General Public License for more details.
 *
 * You should have received a copy of the GNU General Public License
 * along with this program; if not, write to the Free Software
 * Foundation, Inc., 51 Franklin Street, Fifth Floor, Boston, MA  02110-1301, USA.
 *
 * Copyright (c) 2024 (original work) Open Assessment Technologies SA ;
 */

import { getTimersStore } from './timersStore.js';

/**
 * Check if navigation needs to be disabled giving min max timers
 * @param {string} serviceCallId
 * @param {object} currentTestPart
 * @param {string} itemIdentifier
 * @returns {boolean}
 */
export function isNavigationDisabledByTimers(serviceCallId, currentTestPart, itemIdentifier) {
    if (!serviceCallId || !currentTestPart || !itemIdentifier) {
        return false;
    }
    const timersStore = getTimersStore(serviceCallId);
    if (!timersStore) {
        return false;
    }
    const areTimersEqual = timersStore.isMinMaxEqual(itemIdentifier);
    //leave nav disabled only if timers are equal and test is linear otherwise enable it
    return areTimersEqual && currentTestPart.isLinear;
}
